<template>
  <div>
    <v-flex xs12 sm10 md8 lg10>
      <v-card v-if="assignment">
        <v-container>
          <v-layout row wrap>
            <v-flex d-flex>
              <v-list two-line>
                <v-list-tile>
                  <!--                  <v-list-tile-action>-->
                  <!--                    <v-icon color="primary">folder</v-icon>-->
                  <!--                  </v-list-tile-action>-->
                  <v-list-tile-content>
                    <v-list-tile-title>{{ format(assignment.created) }}</v-list-tile-title>
                    <v-list-tile-sub-title>Aangemaakt</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ assignment.assignment }}</v-list-tile-title>
                    <v-list-tile-sub-title>Omschrijving</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <!--                  <v-list-tile-action>-->
                  <!--                    <v-icon color="primary">folder</v-icon>-->
                  <!--                  </v-list-tile-action>-->
                  <v-list-tile-content>
                    <v-list-tile-title>{{ assignment.client }}</v-list-tile-title>
                    <v-list-tile-sub-title>Klant</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ assignment.area }}</v-list-tile-title>
                    <v-list-tile-sub-title>Wijk</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
            <v-flex d-flex>
              <v-list two-line>
                <v-list-tile>
                  <!--                  <v-list-tile-content>-->
                  <!--                    <v-list-tile-title>{{ assignment.created }}</v-list-tile-title>-->
                  <!--                    <v-list-tile-sub-title>Aangemaakt</v-list-tile-sub-title>-->
                  <!--                  </v-list-tile-content>-->
                </v-list-tile>
                <v-list-tile>
                  <v-text-field xs12 v-model="idAssignment"></v-text-field>
                </v-list-tile>
                <v-list-tile>
                  <v-select xs12 v-model="selectedClient" :items="clients" item-text="name" item-value="name"
                            return-object
                            @change="populateAreas"></v-select>
                </v-list-tile>
                <v-list-tile>
                  <v-select xs12 v-model="selectedArea" :items="areaitems"></v-select>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-layout>
        </v-container>
        <v-layout>
          <v-spacer/>
          <v-btn @click="cancel()">Annuleer</v-btn>
          <v-btn color="primary" @click="save()">Opslaan</v-btn>
        </v-layout>
      </v-card>
    </v-flex>
  </div>
</template>
<script>
import {adminService, cookieService} from "@/services/admin";
import {sharedClientService} from '@/services/shared'
import moment from "moment";


export default {
  data: () => ({
    assignmentId: "",
    assignment: null,
    selectedClient: null,
    selectedArea: null,
    areaitems: [],
    idAssignment: null,
    file: null,
    filename: null,
    count: 0,
    uploadSuccesful: false,
    errorOccurred: false,
    valid: undefined,
    sending: false,
    clients: []
  }),
  computed: {
    // ...mapGetters({
    //   clients: "clientList",
    // })
  },
  methods: {
    // ...mapActions([
    //   "loadClients"
    // ]),
    clear() {
      this.idAssignment = null;
      this.selectedClient = null;
      this.file = null;
      this.filename = null;
      this.selectedArea = null;
      this.areaitems = [];
      this.clients = [];
    },
    save() {
      let assignment = {
        'id': this.assignment.uniqueID,
        'client': this.selectedClient.name,
        'assignment': this.idAssignment,
        'area': this.selectedArea
      }
      // eslint-disable-next-line no-unused-vars
      adminService.updateAssignment(assignment).then(response => this.$router.push("/admin/assignments"));
    },
    cancel() {
      this.$router.push("/admin/assignments");
    },
    format(date) {
      if (date) {
        let curMoment = moment(date);
        curMoment.locale("nl");
        let formatDate = curMoment.format("dddd D MMMM YYYY");
        let formatTime = curMoment.format("HH.mm");

        return `${formatDate} om ${formatTime}`;
      }
      return "onbekend";
    },
    populateAreas() {
      if (this.selectedClient) {
        this.areaitems = this.selectedClient.areas;
      }
    },
  },
  created() {
    this.assignmentId = cookieService.load(cookieService.ACTIVE_ASSIGNMENT_ID)
    sharedClientService.resolveClients().then(response => {
      this.clients = response.data.content;
      adminService.getAssignment(this.assignmentId).then(result => {
        this.assignment = result.data;
        this.idAssignment = this.assignment.assignment;
        this.clients.filter(item => item.name === this.assignment.client)
            .forEach(item => {
              this.selectedClient = item;
              this.areaitems = this.selectedClient.areas;
              this.selectedArea = this.assignment.area;
            });
      });

    })
  }
}
</script>